import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from "./zh"; // 简体中文
import zhHK from "./zh-HK"; // 繁体中文（香港华浩版本）
import en from "./en"; // 英文版本

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localStorage.getItem("language") || "zh-HK", // 默认繁体中文（香港），从本地存储读取
  fallbackLocale: "zh-HK",
  messages: {
    // zh, // 简体中文
    "zh-HK": zhHK, // 繁体中文（香港）
    en, // 英文
  },
});

export default i18n;
